import React from "react";
import { Text, View, TouchableOpacity, Platform, Image } from "react-native";
import StyleSheet from "react-native-media-query";
import { notificationAsset } from "../../resources/ImageHelper";
import commonStyle from "../../assets/styles/common-style";
import { timeAgo } from "@lib/utilities/TimeAgo";
import Color from "../../assets/color/Color";
import { theme } from "../../theme/theme";

const NotificationListItem = (props: any) => {
  const notificationItem = props.notificationItem;

  return (
    <TouchableOpacity
      key={notificationItem.id}
      onPress={() => props.onItemPress()}
    >
      <View
        style={[
          styles.notificationList,
          notificationItem.isRead ? styles.alreadyReadList : "",
        ]}
        dataSet={{ media: ids.notificationList }}
      >
        <View
          style={[
            styles.notificationIcon,
            notificationItem.isRead ? styles.alreadyRead : "",
          ]}
          dataSet={{ media: ids.notificationIcon }}
        >
          <Image
            style={styles.dollarIcon}
            source={notificationAsset(
              notificationItem.notificationTypeId,
              notificationItem.isRead
            )}
          />
        </View>
        <View
          style={[commonStyle.styles.colFlex, styles.notificationWraper]}
          dataSet={{ media: commonStyle.ids.colFlex }}
        >
          <Text
            style={[
              styles.notificationText,
              notificationItem.isRead ? styles.alreadyReadText : "",
            ]}
            dataSet={{ media: ids.notificationText }}
          >
            {notificationItem.message.body}
          </Text>
          <Text
            style={[styles.notificationDate]}
            dataSet={{ media: ids.notificationDate }}
          >
            {timeAgo(notificationItem.createdAt)}
          </Text>
        </View>
      </View>
    </TouchableOpacity>
  );
};

const { ids, styles } = StyleSheet.create({
  notificationWraper: {
    width: "100%",
  },
  dollarIcon: {
    ...Platform.select({
      ios: {
        width: undefined,
        // Without height undefined it won't work
        height: "80%",
        // figure out your image aspect ratio
        aspectRatio: 1,
      },
      android: {
        width: undefined,
        // Without height undefined it won't work
        height: "80%",
        // figure out your image aspect ratio
        aspectRatio: 1,
      },
      web: {
        width: "60%",
        // Without height undefined it won't work
        height: undefined,
        // figure out your image aspect ratio
        aspectRatio: 12 / 16,
      },
    }),
  },
  notificationDate: {
    fontFamily: theme.fontFamily.robotoRegular,
    color: theme.colors.black + 90,
    marginTop: 4,
  },
  alreadyReadList: {
    backgroundColor: theme.colors.white,
  },
  alreadyRead: {
    backgroundColor: theme.colors.black + 20,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: theme.colors.black + 30,
  },
  alreadyReadText: {
    fontSize: 16,
    fontWeight: "400",
    lineHeight: 24,
    letterSpacing: 0,
    textAlign: "left",
    color: theme.colors.text.secondary,
  },
  notificationList: {
    padding: 16,
    backgroundColor: theme.colors.notification.unread + "10",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.text.secondary + 15,
    ...Platform.select({
      ios: {},
      android: {},
      web: {
        cursor: "pointer",
      },
    }),
  },
  notificationIcon: {
    width: 33,
    height: 33,
    borderRadius: 33,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.colors.notification.unread + 40,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: theme.colors.notification.unread + 80,
    marginRight: 16,
    position: "relative",
    top: 7,
  },
  notificationText: {
    fontSize: 16,
    fontWeight: "500",
    fontStyle: "normal",
    lineHeight: 24,
    letterSpacing: 0,
    textAlign: "left",
    color: theme.colors.text.secondary,
    fontFamily: theme.fontFamily.robotoSlabBold,
    ...Platform.select({
      ios: {
        paddingRight: 46,
      },
      android: {
        paddingRight: 46,
      },
      web: {
        cursor: "pointer",
        width: "90%",
        flex: 1,
        paddingRight: 30,
      },
    }),
  },
});

export default NotificationListItem;
